/* ============================================================
   Collection Filters Toggle — v15
   (Desktop slide reveal + sticky | Mobile bottom sheet + Clear all)

   v15 FIX — "2nd open pe width 126px":
   • ROOT CAUSE: deskMeasure() ka style.cssText='' #gf-tree ki
     Globo-set inline width (20%) bhi wipe kar deta tha. Pehli
     open sahi naapti thi (style abhi zinda thi), hide/show ke
     baad width source khatam → flex negotiation → 126px.
   • clearOurStyles(): sirf HUMARI inline props clear hoti hain
   • Measure ke waqt inner width temporarily reset (first-load
     jaisi intrinsic conditions)
   • lastGood width sanity — suspicious shrink reject
   ============================================================ */
(function () {
  var KEY = 'df:collection-filters-open';
  var mq = window.matchMedia('(min-width: 990px)');
  var mode = null;
  var gf = null, origParent = null, origNext = null;
  var sheet = null; /* {ov, panel, body} */
  var D = { col: null, inner: null, cfg: null, lastGood: 0 };
  var flipAt = 0;
  var verifyTimers = [];
  var toggleGen = 0;

  /* ================= STATE HELPERS ================= */
  function isOpen() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function saveState(v) { try { sessionStorage.setItem(KEY, v ? '1' : '0'); } catch (e) {} }
  function getScope() { return document.querySelector('.collection.filters--sidebar'); }
  function getTree() { return document.querySelector('.gf-filter-contents'); }

  function setBtn(open) {
    var btn = document.getElementById('CollectionFiltersToggle');
    if (!btn) return;
    btn.setAttribute('aria-expanded', String(open));
    var l = btn.querySelector('.collection-filters-toggle__label');
    if (l) l.textContent = open ? (btn.dataset.labelHide || 'Hide filters') : (btn.dataset.labelShow || 'Show filters');
  }

  function setStickyTop() {
    var c = document.querySelector('.section-header, header, .header-wrapper, .site-header');
    var t = c ? Math.round(c.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--gf-sticky-top', (t + 16) + 'px');
  }

  /* ================= GLOBO GRAB / RESTORE ================= */
  function grabGf() {
    gf = getTree();
    if (gf && !origParent) { origParent = gf.parentNode; origNext = gf.nextSibling; }
    return gf;
  }
  function restoreGf() {
    gf = getTree();
    if (gf && origParent && gf.parentNode !== origParent) origParent.insertBefore(gf, origNext);
  }

  /* ================= MOBILE PREMIUM SHEET ================= */
  function ensureSheet() {
    if (sheet) return sheet;
    var ov = document.createElement('div');
    ov.className = 'gf-sheet-overlay';

    var panel = document.createElement('div');
    panel.className = 'gf-sheet-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.innerHTML =
      '<div class="gf-sheet-header">' +
        '<span class="gf-sheet-grip"></span>' +
        '<div class="gf-sheet-head-row">' +
          '<span class="gf-sheet-title">Filters<span class="gf-sheet-badge" style="display:none"></span></span>' +
          '<button type="button" class="gf-sheet-close" aria-label="Close filters">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
            '<line x1="5" y1="5" x2="19" y2="19"/><line x1="19" y1="5" x2="5" y2="19"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>' +
      '<div class="gf-sheet-body"></div>' +
      '<div class="gf-sheet-footer">' +
        '<button type="button" class="gf-sheet-clear">Clear all</button>' +
        '<button type="button" class="gf-sheet-apply">Show results</button>' +
      '</div>';

    document.body.appendChild(ov);
    document.body.appendChild(panel);
    sheet = { ov: ov, panel: panel, body: panel.querySelector('.gf-sheet-body') };

    ov.addEventListener('click', closeSheet);
    panel.querySelector('.gf-sheet-close').addEventListener('click', closeSheet);
    panel.querySelector('.gf-sheet-apply').addEventListener('click', closeSheet);
    panel.querySelector('.gf-sheet-clear').addEventListener('click', clearAll);

    var bt;
    sheet.body.addEventListener('click', function () {
      clearTimeout(bt);
      bt = setTimeout(updateBadge, 200);
    });

    return sheet;
  }

  function updateBadge() {
    if (!sheet) return;
    var n = sheet.panel.querySelectorAll('[aria-checked="true"]').length;
    var b = sheet.panel.querySelector('.gf-sheet-badge');
    if (!b) return;
    b.textContent = n;
    b.style.display = n ? 'inline-flex' : 'none';
  }

  /* Clear all: URL se saare filter params hata do (sort/search preserve) */
  function clearAll() {
    var params = new URLSearchParams(window.location.search);
    var keep = new URLSearchParams();
    if (params.get('q')) keep.set('q', params.get('q'));
    if (params.get('sort_by')) keep.set('sort_by', params.get('sort_by'));
    var qs = keep.toString();
    window.location.href = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
  }

  function openSheet() {
    if (!grabGf()) return;
    var s = ensureSheet();
    s.body.appendChild(gf);
    updateBadge();
    void s.panel.offsetWidth;
    s.panel.classList.add('gf-open');
    s.ov.classList.add('gf-show');
    document.body.classList.add('gf-no-scroll');
    var sc = getScope(); if (sc) sc.classList.remove('filters-collapsed');
    setBtn(true); saveState(true);
  }

  function closeSheet() {
    if (mode !== 'mob' || !sheet) return;
    sheet.panel.classList.remove('gf-open');
    sheet.ov.classList.remove('gf-show');
    document.body.classList.remove('gf-no-scroll');
    var sc = getScope(); if (sc) sc.classList.add('filters-collapsed');
    setBtn(false); saveState(false);
  }

  /* Duplicate mobile filter buttons hide (Globo ka "Filter By" etc.) */
  function hideDupButtons() {
    if (mq.matches) return;
    document.querySelectorAll('button, a, summary, [role="button"]').forEach(function (el) {
      if (el.closest('.collection-filters-toggle') || el.closest('.gf-sheet-panel')) return;
      var t = (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (t === 'filter by' || t === 'filter' || t === 'filters' || t.indexOf('filter by') === 0) {
        var box = (el.parentElement && (el.parentElement.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase() === t) ? el.parentElement : el;
        box.style.setProperty('display', 'none', 'important');
      }
    });
  }

  /* ================= DESKTOP (slide reveal + sticky) ================= */
  function findCol() {
    var g = getTree();
    if (!g) return null;
    var el = g, guard = 0;
    while (el && guard++ < 6) {
      var sib = el.nextElementSibling;
      while (sib) {
        if (sib.querySelector && (sib.querySelector('#product-grid') || sib.querySelector('.collection__grid'))) return el;
        sib = sib.nextElementSibling;
      }
      el = el.parentElement;
    }
    return null;
  }

  function treeWidth() {
    var t = getTree();
    if (!t || !t.firstChild) return 0;
    return Math.round(t.getBoundingClientRect().width);
  }

  /* [v15] Sirf HUMARI inline props clear karo — Globo ki inline
     styles (#gf-tree width etc.) KABHI wipe mat karo */
  function clearOurStyles(el) {
    el.style.width = '';
    el.style.margin = '';
    el.style.padding = '';
    el.style.overflow = '';
    el.style.boxSizing = '';
    el.style.flexShrink = '';
    el.style.minWidth = '';
    el.style.transition = '';
  }

  function deskMeasure() {
    clearOurStyles(D.col);

    /* [v15] inner ka width:100% temporarily hatao — pehli measure
       jaisi intrinsic conditions recreate (warna 2nd measure alag) */
    var innerW = '';
    if (D.inner) { innerW = D.inner.style.width; D.inner.style.width = ''; }

    var w = D.col.getBoundingClientRect().width;

    /* Fallback 1: Globo tree ka apna live width */
    var tw = treeWidth();
    if (tw > w) w = tw;
    /* Fallback 2: max-content trick */
    if (w < 120) {
      D.col.style.width = 'max-content';
      w = D.col.getBoundingClientRect().width;
      D.col.style.width = '';
    }
    /* Fallback 3: sane default */
    if (w < 120) w = Math.min(320, Math.round(window.innerWidth * 0.25));

    /* [v15] Sanity: bina resize/flip ke pehle se kaafi chhoti
       width aayi = bad measurement → last good width prefer */
    if (D.lastGood && w < D.lastGood * 0.55 && (Date.now() - flipAt) > 2000) {
      w = D.lastGood;
    }
    if (w >= 120) D.lastGood = Math.round(w);

    /* inner width wapas */
    if (D.inner) D.inner.style.width = innerW || '100%';

    var cs = getComputedStyle(D.col);
    D.cfg = {
      width: Math.round(w),
      m: cs.marginTop + ' ' + cs.marginRight + ' ' + cs.marginBottom + ' ' + cs.marginLeft,
      p: cs.paddingTop + ' ' + cs.paddingRight + ' ' + cs.paddingBottom + ' ' + cs.paddingLeft
    };

    D.col.style.overflow = 'hidden';
    D.col.style.boxSizing = 'border-box';
    D.col.style.flexShrink = '0';
    D.col.style.minWidth = '0';
  }

  function deskWrap() {
    D.inner = D.col.querySelector(':scope > .gf-slide-inner');
    if (D.inner) return;
    D.inner = document.createElement('div');
    D.inner.className = 'gf-slide-inner';
    while (D.col.firstChild) D.inner.appendChild(D.col.firstChild);
    D.col.appendChild(D.inner);
    D.inner.style.width = '100%';
    D.inner.style.boxSizing = 'border-box';
  }

  function deskApply(open, animate) {
    if (!D.col || !D.inner) return;
    var EASE = 'cubic-bezier(.22,.61,.36,1)';
    if (animate) {
      D.col.style.transition = 'width .5s ' + EASE + ', padding .5s ' + EASE + ', margin .5s ' + EASE;
      D.inner.style.transition = 'opacity .4s ease, transform .5s ' + EASE;
    } else { D.col.style.transition = 'none'; D.inner.style.transition = 'none'; }

    if (open) {
      D.col.style.width = D.cfg.width + 'px';
      D.col.style.margin = D.cfg.m; D.col.style.padding = D.cfg.p;
      D.inner.style.opacity = '1'; D.inner.style.transform = 'none';
    } else {
      D.col.style.width = '0px'; D.col.style.margin = '0'; D.col.style.padding = '0';
      D.inner.style.opacity = '0'; D.inner.style.transform = 'translateX(-24px)';
    }
    if (!animate) { void D.col.offsetWidth; D.col.style.transition = ''; D.inner.style.transition = ''; }
    var s = getScope(); if (s) s.classList.toggle('filters-collapsed', !open);
    setBtn(open); saveState(open);
  }

  function clearVerifiers() {
    verifyTimers.forEach(clearTimeout);
    verifyTimers = [];
  }

  /* Post-open verifier — Globo late re-render kare to ANIMATED correction */
  function startVerifier() {
    clearVerifiers();
    [400, 900, 1600, 2500].forEach(function (ms) {
      verifyTimers.push(setTimeout(function () {
        if (mode !== 'desk' || !isOpen() || !D.col || !D.inner || !D.col.isConnected) return;
        var tw = treeWidth();
        if (tw >= 120 && Math.abs(tw - D.cfg.width) > 4) {
          D.cfg.width = tw;
          D.lastGood = tw;
          deskApply(true, true);
        }
      }, ms));
    });
  }

  /* Open with stability gate — isOpen() pe depend NAHI karta */
  function openDesk(animate, gen) {
    if (typeof gen !== 'number') gen = ++toggleGen;
    var recent = (Date.now() - flipAt) < 2000;
    var last = -1, stable = 0, tries = 0;

    function attempt() {
      if (gen !== toggleGen) {
        if (D.col && D.inner) deskApply(isOpen(), false);
        return;
      }
      if (!D.col || !D.inner || !D.col.isConnected) return;

      deskMeasure();
      var w = D.cfg.width;
      if (w >= 120 && Math.abs(w - last) <= 2) stable++; else stable = 0;
      last = w;
      if ((w >= 120 && (!recent || stable >= 1)) || ++tries >= 20) {
        deskApply(true, animate);
        startVerifier();
      } else {
        setTimeout(attempt, 200);
      }
    }
    attempt();
  }

  /* ================= INIT ================= */
  function init() {
    toggleGen++;
    setStickyTop();
    mode = mq.matches ? 'desk' : 'mob';

    if (mode === 'mob') {
      restoreGf();
      if (D.col) {
        if (D.inner && D.inner.parentNode === D.col) {
          while (D.inner.firstChild) D.col.insertBefore(D.inner.firstChild, D.inner);
          D.inner.remove();
        }
        clearOurStyles(D.col);
        D.col.classList.remove('gf-col');
        if (D.col.parentElement) D.col.parentElement.classList.remove('gf-row');
      }
      D.col = null; D.inner = null;
      clearVerifiers();
      if (sheet) { sheet.panel.classList.remove('gf-open'); sheet.ov.classList.remove('gf-show'); }
      document.body.classList.remove('gf-no-scroll');
      hideDupButtons();
      setBtn(false); saveState(false);
      var sc = getScope(); if (sc) sc.classList.add('filters-collapsed');
      return;
    }

    restoreGf();
    hideDupButtons();

    if (sheet) {
      sheet.panel.classList.remove('gf-open');
      sheet.ov.classList.remove('gf-show');
      document.body.classList.remove('gf-no-scroll');
    }

    D.col = findCol();
    if (!D.col) { console.warn('[FilterToggle] desktop column nahi mila'); return; }
    if (D.col.parentElement) D.col.parentElement.classList.add('gf-row');
    D.col.classList.add('gf-col');
    deskMeasure(); deskWrap();

    if (isOpen()) openDesk(false); else deskApply(false, false);
  }

  /* ================= EVENTS ================= */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('#CollectionFiltersToggle')) return;
    if (mode === 'mob') { isOpen() ? closeSheet() : openSheet(); return; }
    toggleGen++;
    var gen = toggleGen;
    if (!D.col || !D.inner) init();
    if (!D.col || !D.inner) return;
    if (!isOpen()) openDesk(true, gen);
    else deskApply(false, true);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mode === 'mob') closeSheet();
  });

  function onMqChange() { flipAt = Date.now(); init(); }
  if (mq.addEventListener) mq.addEventListener('change', onMqChange); else mq.addListener(onMqChange);

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () {
      if (mode === 'desk' && D.col && D.inner) {
        setStickyTop(); deskMeasure(); deskWrap();
        deskApply(isOpen(), false);
        if (isOpen()) startVerifier();
      }
    }, 150);
  });

  var moT;
  var mo = new MutationObserver(function () {
    clearTimeout(moT);
    moT = setTimeout(function () {
      if (mode === 'mob') { hideDupButtons(); return; }
      if (D.col && !D.col.isConnected) { D.col = null; D.inner = null; init(); }
      if (isOpen() && mode === 'desk') startVerifier();
    }, 300);
  });
  try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}

  /* Globo late render safety */
  setTimeout(function () { if (mode === 'mob') hideDupButtons(); }, 1500);

  /* ================= BOOT ================= */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})(); 